import { useQuery } from 'react-query';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';

const fetchComparePlansDisplayOrder = async (clientId: string): Promise<string[]> =>
  authFetch(`/Consumer/ComparePlan/GetDisplayOrder?clientId=${clientId}`);

interface ComparePlansDisplayOrderQueryParams {
  clientId: string;
  enabled?: boolean;
}

export const useComparePlansDisplayOrderQuery = ({
  clientId,
  enabled = true,
}: ComparePlansDisplayOrderQueryParams) => {
  return useQuery(
    queryKeys.comparePlansDisplayOrder(clientId),
    () => fetchComparePlansDisplayOrder(clientId),
    {
      enabled: Boolean(clientId) && enabled,
    },
  );
};
